export default __webpack_public_path__ + "static/banner_waw-a58b431b35dfdeffb27bd54d1b679b7a.jpg";